import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../reducers";
import { bindActionCreators } from "redux";
import * as action from '../actions/games';
import { useRouter } from "../../helpers/customHooks";
import { Game } from "../../config/commonTypes";

export const useGamesState = () => {
  const games = useSelector((state: RootState) => state.games) as Array<Game>;
  return games;
};
export const usePlaysState = () => {
  const playsIgnored = useSelector((state: RootState) => state.playsIgnored);
  return {playsIgnored};
};

type Match = { id: string; }

export const useGamesDispatch = () => {
  const { match } = useRouter();
  const dispatch = useDispatch();
  return { 
    ...bindActionCreators({ ...action }, dispatch),
    loadGames: () => {
      const { id } = match.params as Match; //for team view id is teamId
      dispatch(action.getGames(id));
    },
    getIgnorePlays:(gameId:string) => dispatch(action.getIgnorePlays(gameId)),
    reprocessGame: (gameId: string) => dispatch(action.reprocessGame(gameId))
   };
};